// @ts-nocheck

/**
 * * `not_started` - Not Started
 * `pending` - Pending
 * `generating` - Generating
 * `completed` - Completed
 * `failed` - Failed
 */
export type AvatarGenerationStatusEnum =
  typeof AvatarGenerationStatusEnum[keyof typeof AvatarGenerationStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvatarGenerationStatusEnum = {
  not_started: "not_started",
  pending: "pending",
  generating: "generating",
  completed: "completed",
  failed: "failed",
} as const;
